// extracted by mini-css-extract-plugin
module.exports = {"right_panel":"ContactPanel_right_panel__2i-Ym"};